import {
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_REQUEST,
  FETCH_ROLES_FAILURE,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_FAILURE,
  SHOW_ROLE_EDIT_FORM,
  SHOW_ROLE_NEW_FORM,
  SET_ROLE_VALIDATION_ERRORS,
  CREATE_ROLE_REQUEST,
  CREATE_ROLE_SUCCESS,
  CREATE_ROLE_FAILURE,
} from "constants/Role";

import {
  addRole,
  formtValidationErrors,
  updateRole,
} from "utils/Role";

const initState = {
  loading: false,
  updating: false,
  creating: false,
  list: [],
  roles: [],
  permissions: [],
  errorMessage: "",
  validationErrors: [],
  showEditForm: false,
  showNewForm: false,
  deleting: false,
};

const role = (state = initState, action) => {
  switch (action.type) {
    case FETCH_ROLES_REQUEST:
      return {
        ...state,
        loading: true,
        showEditForm: false,
        showNewForm: false,
      };
    case FETCH_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.roles,
        permissions: action.payload.permissions,
      };
    case FETCH_ROLES_FAILURE:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };

    case SET_ROLE_VALIDATION_ERRORS:
      return {
        ...state,
        validationErrors: formtValidationErrors(action.payload),
      };
    case SHOW_ROLE_EDIT_FORM:
      return {
        ...state,
        showEditForm: !state.showEditForm,
      };
    case SHOW_ROLE_NEW_FORM:
      return {
        ...state,
        showNewForm: !state.showNewForm,
      };
    case UPDATE_ROLE_REQUEST:
      return {
        ...state,
        updating: true,
        errorMessage: "",
        validationErrors: [],
      };
    case UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        updating: false,
        list: action.payload.roles,
        permissions: action.payload.permissions,
        errorMessage: "",
        validationErrors: [],
        showEditForm: false,
      };
    case UPDATE_ROLE_FAILURE:
      return {
        ...state,
        updating: false,
        errorMessage: action.payload,
        validationErrors: [],
      };
      case CREATE_ROLE_REQUEST:
        return {
          ...state,
          creating: true,
        };
      case CREATE_ROLE_SUCCESS:
        return {
          ...state,
          creating: false,
          showNewForm: !state.showNewForm,
          list: action.payload.roles,
          permissions: action.payload.permissions,
        }
      case CREATE_ROLE_FAILURE:
        return {
          ...state,
          creating: false,
          errorMessage: action.payload,
        };
    default:
      return state;
  }
};

export default role;
